import * as React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-final-form';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { TravellerFields } from '../../../../TravellerForm/types';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import { CdnIcon } from '@shared/ui';
import { CloseButton } from '../../../../BaseComponents';
import Link from '../../../../Link';
const Header = ({ passengerId, label, numberIcon, correct, onClick, passengerFieldsMap, open, showErrorNotice, hideClearButton }) => {
    const { t } = useTranslation('Passenger');
    const theme = useTheme('PassengerForm').Header;
    const { mutators } = useForm();
    const isMobile = useMediaQuery({ maxWidth: MOBILE_MIN_WIDTH });
    const clearFieldsHandler = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const mutator = mutators['clearFields'];
        mutator(passengerId);
    };
    return (React.createElement("div", { className: cn(theme.header, {
            [theme.filled]: correct,
            [theme.collapsed]: !open,
            [theme.header_error]: showErrorNotice
        }), onClick: onClick },
        React.createElement("div", { className: theme.number }, numberIcon || passengerId + 1),
        React.createElement("div", { className: theme.payload },
            React.createElement("div", { className: theme.passengerName }, label),
            isMobile && showErrorNotice && React.createElement("div", { className: theme.error }, t('Please, check passenger data')),
            isMobile && correct && passengerFieldsMap && (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    passengerFieldsMap[TravellerFields.Gender],
                    ",",
                    ' ',
                    passengerFieldsMap[TravellerFields.BirthDate],
                    ",",
                    ' ',
                    passengerFieldsMap[TravellerFields.Nationality]),
                passengerFieldsMap['docType'] && (React.createElement("div", null,
                    passengerFieldsMap['docType'],
                    ": ",
                    passengerFieldsMap['docNumber'])),
                passengerFieldsMap['docExpiryDate'] && (React.createElement("div", null,
                    t('docExpiryDate'),
                    ": ",
                    passengerFieldsMap['docExpiryDate'])),
                passengerFieldsMap['loyaltyNumber'] && (React.createElement("div", { className: theme.loyalty_number },
                    t('loyaltyNumber'),
                    ": ",
                    passengerFieldsMap['loyaltyNumber']))))),
        correct && !numberIcon && React.createElement(CdnIcon, { className: theme.successIcon, icon: "Info/Item Icluded" }),
        correct && !hideClearButton && (React.createElement(React.Fragment, null, isMobile ? (React.createElement(CloseButton, { variant: "closePopup", className: theme.clearButton, onClick: clearFieldsHandler })) : (React.createElement(Link, { action: clearFieldsHandler, noUderline: true, className: theme.clearLink },
            t('clear'),
            React.createElement(CdnIcon, { icon: "Action/Close-Clear" })))))));
};
export default Header;
